import {
  ToggleButtonGroup as MuiToggleButtonGroup,
  ToggleButtonGroupProps,
} from '@material-ui/lab';
import { ColorDynamic, Stack } from '@superdispatch/ui';
import { useField } from 'formik';
import { ReactNode } from 'react';
import styled from 'styled-components';
import { DriverPreferencesErrorMessage } from './DriverPreferencesErrorMessage';

const ToggleButtonGroup = styled(MuiToggleButtonGroup)`
  width: 100%;
  & .MuiToggleButton-root {
    flex-basis: 0;
    flex-grow: 1;
    border-color: ${ColorDynamic.Dark100};
    color: ${ColorDynamic.Dark100};
    & .MuiSvgIcon-root {
      color: ${ColorDynamic.Dark100};
    }
    & .MuiToggleButton-label {
      color: ${ColorDynamic.Dark300};
    }
    &.Mui-selected {
      background-color: ${ColorDynamic.Blue50};
      border-color: ${ColorDynamic.Blue500};
      color: ${ColorDynamic.Blue500};
      & .MuiSvgIcon-root,
      .MuiToggleButton-label {
        color: ${ColorDynamic.Blue500};
      }
    }
  }
`;

interface FormikToggleButtonGroupProps extends Omit<
  ToggleButtonGroupProps,
  'value'
> {
  children: ReactNode;
  displayError?: boolean;
  name: string;
  validate?: (value: string) => string | Promise<string>;
}

export function FormikToggleButtonGroup({
  name,
  children,
  displayError = true,
  exclusive = true, //only allow one of the child ToggleButton values to be selected.
  validate,
  onChange,
  ...props
}: FormikToggleButtonGroupProps) {
  const [_, field, { setValue }] = useField<string>({ name, validate });

  return (
    <Stack space="small">
      <ToggleButtonGroup
        {...props}
        aria-label={name}
        value={field.value}
        exclusive={exclusive}
        onChange={(event, value: string) => {
          void setValue(value);
          onChange?.(event, value);
        }}
      >
        {children}
      </ToggleButtonGroup>
      {displayError && field.error && field.touched && (
        <DriverPreferencesErrorMessage errorMessage={field.error} />
      )}
    </Stack>
  );
}
